import { render, staticRenderFns } from "./DeclarationCarburant.vue?vue&type=template&id=1077e561&scoped=true&"
import script from "./DeclarationCarburant.vue?vue&type=script&lang=js&"
export * from "./DeclarationCarburant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1077e561",
  null
  
)

export default component.exports